import {Component, computed, input} from "@angular/core";
import {SystemInformationResponse} from "@models";
import {SimConfigurationService} from "@services";
import {NgStyle} from "@angular/common";

type ExtendedSystemInformationResponse = SystemInformationResponse & {
	deviceId?: string;
	autoLoginCapability?: string;
	roomName?: string;
};

@Component({
	selector: "sim-environment-overlay",
	templateUrl: "./environment-overlay.component.html",
	styleUrl: "./environment-overlay.component.scss",
	imports: [NgStyle],
})
export class EnvironmentOverlayComponent {
	protected readonly SimConfigurationService = SimConfigurationService;
	protected readonly window = window;

	public info = input<SystemInformationResponse | null>(null);

	public get color(): string {
		return SimConfigurationService.settings.environmentOverlayColor;
	}

	public readonly version = computed((): string => {
		return this.info()?.versionDisplay?.displayVersion ?? this.info()?.version ?? "";
	});

	public readonly deviceId = computed((): string => {
		return this.extendedInfo()?.deviceId ?? "";
	});

	public readonly autoLoginCapability = computed((): string => {
		return this.extendedInfo()?.autoLoginCapability ?? "";
	});

	public readonly roomName = computed((): string => {
		return this.extendedInfo()?.roomName ?? "";
	});

	public readonly extendedInfoEnabled = computed((): boolean => {
		return (
			(SimConfigurationService.settings as {environmentOverlayExtendedInfoEnabled?: boolean})
				?.environmentOverlayExtendedInfoEnabled ?? false
		);
	});

	private extendedInfo(): ExtendedSystemInformationResponse | null {
		return this.info() as ExtendedSystemInformationResponse | null;
	}
}
